import React from 'react'
import NewActionButton from './ActionButtons/NewActionButton';
import { useTranslate } from './TranslationText';
import { formatDate } from '../helper/formatDate';
import NetaqInput from './NetaqInput';
import { noDataCard } from '../common/cssclasses';

export default function HorsesAboveThirty({ isNoAction = false, isEdit, oldHorsesList = [], takeAction = () => { }, setDateOfBirth = () => { } }) {
    const { translate } = useTranslate();
    let list = !isEdit
        ? oldHorsesList?.filter(item => item.isDead === true)
        : oldHorsesList;
    if (isNoAction) {
        list = oldHorsesList;
    }

    if (list?.length == 0) {
        return (
            <>
                <h5>
                    {translate('web.deadHorsesConfirmationMsg', 'Dead Horses Confirmation Msg')}
                </h5>
                <div className={noDataCard}>
                    {translate('web.noHorsesFound', 'No Horses Found')}
                </div>
            </>
        )
    }

    return list?.length > 0 && <>
        {!isNoAction && <>
            {!isEdit &&
                <h5>
                    {translate('web.deadHorsesConfirmationMsg', 'Dead Horses Confirmation Msg')}
                </h5>
            }
        </>}
        <div className="scrolableTable mb-main">
            <table className="table table-striped table-bordered rtl horseResultTable">
                <thead className="theadHorseSelect">
                    <tr>
                        <th className="text-center">
                            {translate("web.regNo", "Reg No")}
                        </th>
                        <th className="text-center">
                            {translate("web.horseName", "Horse Name")}
                        </th>
                        <th className="text-center">
                            {translate("web.birthDate", "Birth Date")}
                        </th>
                        <th className="text-center">
                            {translate("web.ownerRegNo", "Owner Reg")}
                        </th>
                        <th className="text-center">
                            {translate("web.ownerName", "Owner Name")}
                        </th>
                        {!isNoAction && <>
                            <th className="text-center">
                                {translate("web.action", "is Dead")}
                            </th>
                            <th className="text-center">
                                {translate("web.deathDate", "Date Of Death")}
                            </th>
                        </>}
                    </tr>
                </thead>
                <tbody className="text-center">
                    {list.map((item, index) => (
                        <tr key={item?.id}>
                            <td style={{ fontSize: 13 }}>{item?.registerNumber}</td>
                            <td style={{ fontSize: 13 }}>{item?.name}</td>
                            <td style={{ fontSize: 13 }}>{item?.birthDate}</td>
                            <td style={{ fontSize: 13 }}>{item?.ownerReg}</td>
                            <td style={{ fontSize: 13 }}>{item?.owner}</td>
                            {!isNoAction && <>
                                <td style={{ fontSize: 13 }}>
                                    {isEdit && <>
                                        <div className="d-flex">
                                            <NewActionButton
                                                classNames={`btn-success  w-unset mx-auto opacity-75 `}
                                                moreStyle={{ opacity: item?.isDead == false ? 100 : 0.75 }}
                                                text={translate('web.alive', 'Alive')}
                                                onClick={() => takeAction(false, item?.id)} />
                                            <NewActionButton
                                                classNames={`btn-danger w-unset mx-auto opacity-75 ${item?.isDead == true ? "opacity-100" : ''}  `}
                                                moreStyle={{ opacity: item?.isDead == true ? 100 : 0.75 }}

                                                text={translate('web.dead', 'Dead')}
                                                onClick={() => takeAction(true, item?.id)} />
                                        </div>
                                    </>}
                                    {!isEdit && translate('web.dead', 'Dead')}
                                </td>
                                <td style={{ fontSize: 13 }}>
                                    {isEdit && <>
                                        {item?.isDead != false &&
                                            <NetaqInput key={item?.id + 'DeadDate'} value={!!item?.dateOfDeath ? formatDate(item?.dateOfDeath, true, true) : null} maxDate={formatDate(new Date(), false, true)} hideLable type={"normalDate"} name={'Date Of Death'} disabled={item?.isDead == false} onChange={(e) => {
                                                setDateOfBirth(item?.id, e.target.value);
                                            }} />}
                                        {item?.isDead == false &&
                                            <NetaqInput key={item?.id + 'just disabled field'} hideLable type={"normalDate"} name={'Date '} disabled={true} onChange={(e) => {
                                            }} />}
                                    </>}
                                    {!isEdit && item?.dateOfDeath}

                                </td>
                            </>}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </>
        ;
}
